(function () {
	const productMarkers = (section) => {
		let parent = document.currentScript
			? document.currentScript.parentElement
			: section;

		let productsSelector = ".product-markers-for-mobile .product-markers__item-inner";
		let markersSelector = ".js-product-markers__item";

		var products = parent?.querySelectorAll(productsSelector);
		var markers = parent?.querySelectorAll(markersSelector);

		if (parent) {
			markers.forEach((item) => {
				item.addEventListener("click", (event) => {
					event.stopPropagation();
					const index = item.dataset.index;

					// If the clicked marker is already active, deactivate it and its associated product
					if (item.classList.contains("active")) {
						item.classList.remove("active");
						let product = parent.querySelector(
							`${productsSelector}[data-index="${index}"]`
						);
						product?.classList.remove("active");
					} else {
						// Otherwise, remove 'active' from all markers and products
						markers.forEach(marker => marker.classList.remove("active"));
						products.forEach(product => product.classList.remove("active"));

						// Activate the clicked marker and its corresponding product
						item.classList.add("active");
						let product = parent.querySelector(
							`${productsSelector}[data-index="${index}"]`
						);
						product?.classList.add("active");

						// Ensure parent container gets 'active' class
						parent.querySelector(".product-markers-for-mobile").classList.add("active");
					}
				});
			});

			// Trigger the first marker programmatically if needed
			parent.querySelector(markersSelector)?.click();
		}

		// Handle click outside markers or products
		document.addEventListener("click", (e) => {
			const parentClicked = e.target.closest(markersSelector);
			if (!parentClicked && !e.target.closest(productsSelector)) {
				// Remove 'active' from all markers and products
				markers?.forEach(marker => marker.classList.remove("active"));
				products?.forEach(product => product.classList.remove("active"));
			}
		});
	};

	productMarkers();

	document.addEventListener("DOMContentLoaded", function () {
		productMarkers();

		document.addEventListener("shopify:section:load", function (section) {
			productMarkers(section.target);
		});
	});
})();
